// Mock data for ZURIAN Teaser Website


export const brandContent = {
  brandName: "ZURIAN",
  tagline: "Shining Memories",
  launchTimestamp: new Date('2026-04-19T14:30:00+05:30').getTime(),

  // Brand Thesis Content
  brandThesis: {
    title: "Why ZURIAN",
    whatWeAre: {
      paragraph1: "Lifestyle Brand Centred Around Wearable Silver.",
      paragraph2: "ZURIAN stands for elevated lifestyle, harmony, and connection. We provide you with intent, so your intelligent investment for you and yours Appreciate in Meaning and Value.",
      paragraph2b: "ZURIAN is for those who want to express who and what they CHERISH, and how they CELEBRATE LIFE. It is for those who align with the value of SILVER \u2013 a symbol of HARMONY and WEALTH."
    },
    whyWeExist: {
      paragraph1: "Traditional to Daily Lifestyle Standards.",
      paragraph2: "Appearance and Behaviour are the first markers of judgement. ZURIANS know this \u2013 and shine brighter in both, their personal philosophy and in their wearables.",
      paragraph2b: "Our mission: To make ZURIANS\u2019 life meaningful \u2013 with noble silver wear \u2013 for GRACEFUL living.",
      paragraph2c: "ZURIANS get a LIFESTYLE that blends timeless Indian heritage with modern elegance, for you to easily express your personal stories."
    }
  },

  // Early Access CTA
  earlyAccessCTA: {
    text: "ZURIAN Reserve is earned, not merely purchased. Initial wise soul bearers receive exclusive access to: Reserve, founding-tier privileges, and an invitation into a community of ZURIANS."
  },

  // Built With Intent Values
  values: [
    {
      id: 1,
      title: "Dharma",
      description: "Every creation is an act of right intention \u2013 ethically sourced, honestly priced, made to endure."
    },
    {
      id: 2,
      title: "Grace",
      description: "To move through life without force. Grateful, open, and fluid \u2013 with or without adornment."
    },
    {
      id: 3,
      title: "Intellect",
      description: "Choose with purpose. A Zurian invests wisely \u2013 in silver, in people, and in values that last."
    },
    {
      id: 4,
      title: "Experience",
      description: "Life\u2019s finest moments deserve to be marked. Every ZURIAN piece is a Shining Memory in the making."
    },
    {
      id: 5,
      title: "Presentation",
      description: "Before you speak, you are already seen. Your silver is your silent introduction \u2013 chosen with intention."
    }
  ],

  // Contact Info
  contact: {
    companyName: "Zurian International Private Limited",
    email: "care@zurian.co.in",
    instagram: "@zurian.co.in"
  }
};


